import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const RqmtTestList = ({ rqmtId, testId }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (rqmtId) {
      const parentFilterAugRowsReq = EntityUtils.parentFilterAugRowsReq('RQMT', rqmtId);
      parentFilterAugRowsReq(rowsReq);
    } else if (testId) {
      const parentFilterAugRowsReq = EntityUtils.parentFilterAugRowsReq('TEST', testId);
      parentFilterAugRowsReq(rowsReq);
    }
  }, [rqmtId, testId]);

  return <EntityList entity="RQMT_TEST" augRowsReq={augRowsReq} />
}